<template>
  <CoverPage :cover="login_background_image">
    <div class="tw:flex tw:flex-col tw:gap-8">
      <img
        class="tw:max-w-[170px] tw:max-h-[80px] tw:object-contain tw:object-left"
        loading="lazy"
        :src="logo || logoVoomp"
        alt="logo"
      />
    </div>
    <Form ref="observer" v-slot="{ errors, values }" class="tw:flex tw:flex-col tw:gap-8">
      <div class="tw:flex tw:flex-col tw:gap-4">
        <ButtonPlayV2 icon="arrow_back" variant="outline" size="sm" :text="$t('general.back')" class="tw:self-start" @click="onBack" />
        <TextPlay :text="$t('auth.password_reset.title')" size="xl" weight="bold" />
        <TextPlay :text="$t('auth.password_reset.description')" size="sm" weight="regular" />
      </div>

      <div class="tw:flex tw:flex-col tw:gap-5">
        <FormFieldPlay
          id="email"
          as="InputPlayV3"
          name="email"
          label="E-mail"
          rules="required|email"
          type="email"
          :placeholder="$t('auth.password_reset.email_placeholder')"
          autocomplete="email"
        />
        <!-- TODO: reabilitar quando feature de whatsapp for liberada -->
        <div v-if="false && featureWhatsappNotification" class="tw:flex tw:flex-col tw:gap-2">
          <TextPlay :text="$t('auth.password_reset.receive_link_label')" size="sm" weight="semibold" />
          <div class="tw:flex tw:gap-4">
            <InputRadioPlay
              id="type-email"
              v-model="recoveryType"
              name="recovery-type"
              value="email"
              label="E-mail"
            />
            <InputRadioPlay
              id="type-whatsapp"
              v-model="recoveryType"
              name="recovery-type"
              value="whatsapp"
              :label="$t('auth.password_reset.whatsapp_label')"
            />
          </div>
        </div>
        <CaptchaButton type="normal" :text="'Enviar'" :disabled="Object.keys(errors).length > 0 || !values.email" captcha="ADMIN" @click="onSubmit" />
        <TextPlay :text="$t('auth.password_reset.reminder')" size="sm" color="var(--text-color)" />
      </div>
    </Form>
  </CoverPage>
</template>

<script lang="ts" setup>
import { CaptchaButton, InputRadioPlay } from '@/components/atomic';
import { toast } from '@/events';
import { play } from '@voomp/play-back';
import { Form } from 'vee-validate';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStateStore } from '@/store/state.store';
import CoverPage from '@/components/common/CoverPage/CoverPage.vue';
import { FormFieldPlay } from '@/components/atomic';
import defaultCover from '@/assets/img/default_cover.png';
import logoVoomp from '@/assets/img/logo_voomp.png';

const { t } = useI18n();
const _email = ref('');
const recoveryType = ref('email');
const router = useRouter()
const stateStore = useStateStore()
const observer = ref<InstanceType<typeof Form> & { values?: Record<string, string> } | null>(null)

const login_background_image = computed(() => {
  return stateStore.site['login_background_image'] || defaultCover
})

const logo = computed(() => {
  return stateStore.site?.['logomarca'] || stateStore.site?.['logo']
})

const featureWhatsappNotification = computed(() => {
  return stateStore.site.feature_whatsapp_notification
})

function onBack() {
  router.replace('/sign-in');
}

async function onSubmit(captcha: string) {
  try {
    const emailValue = observer.value?.values?.email || ''
    await play.auth_creators.newPassword({
      email: emailValue,
      captcha,
      ...(recoveryType.value === 'whatsapp' && { type: 'whatsapp' })
    } as Record<string, unknown>);
    const message = recoveryType.value === 'whatsapp'
      ? t('auth.password_reset.link_sent_whatsapp')
      : t('auth.password_reset.link_sent_email');
    toast.success(message);
    router.replace('/sign-in');
  } catch (error) {
    console.error(error);
    toast.error(t('auth.password_reset.link_send_error'));
  }
}

</script>
